import React, { useState, useEffect } from "react";
import axios from "axios";
import "semantic-ui-css/semantic.min.css";
import { useAuth } from "../../../hook/userAuth";
import { Navigate, Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { BASE_API } from "../../../ruta-server/BaseApi";
import { Loader, Dropdown } from "semantic-ui-react";
import { TableCursosDispoibles } from "../../../components/Users/TableTeachers/Cursos/TableCursosDisponibles";
import { TableCursosAsignados } from "../../../components/Users/TableTeachers/Cursos/TableCursosAsignados";
import { TablePracticantesDisponibles } from "../../../components/Users/TableTeachers/PracticantesProfesionales/TablePracticantesDisponibles";
import Swal from "sweetalert2";
import { TablePracticantesAsignados } from "../../../components/Users/TableTeachers/PracticantesProfesionales/TablePracticantesAsigandos";

function AsignacionCursos() {
  const { auth } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const dataDocente = location.state?.dataDocente;

  useEffect(() => {
    if (!dataDocente) {
      navigate("/gestion-docente");
    }
  }, [dataDocente, navigate]);

  if (!auth?.me?.is_superuser) {
    return <Navigate to={"/"} />;
  }

  return dataDocente ? (
    <LogicaAsignacionCursos datosDocente={dataDocente} />
  ) : null;
}

function LogicaAsignacionCursos({ datosDocente }) {
  const { auth } = useAuth();
  const [refetch, setRefetch] = useState(false);
  const [cursosAsignadosTitulacion, setCursosAsignadosTitulacion] = useState(
    []
  );
  const [cursos, setCursos] = useState(null);
  const [cursosDocente, setCursosDocente] = useState(null);
  const [cursosTitulacion, setCursosTitulacion] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("CursosDisponibles"); // Estado para rastrear la pestaña activa
  const [periodos, setPeriodos] = useState(null);
  // eslint-disable-next-line
  const [loadingCursosDocente, setLoadingCursosDocente] = useState(true);
  const [loadingPeriodos, setLoadingPeriodos] = useState(true);
  const [selectedPeriodo, setSelectedPeriodo] = useState(null);
  const [selectedPeriodoId, setSelectedPeriodoId] = useState(null);
  // Obtención de los periodos
  async function getPeriodos() {
    try {
      setLoadingPeriodos(true);
      const response = await axios.get(`${BASE_API}/api/periodo/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });

      const periodos = response.data;
      setLoadingPeriodos(false);
      setPeriodos(periodos);
      return periodos;
    } catch (error) {
      setLoadingPeriodos(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getPeriodos();
    // eslint-disable-next-line
  }, [refetch]);

  const getPeriodoMasReciente = (periodos) => {
    if (!periodos || periodos.length === 0) return null;
    const periodoMasReciente = periodos.reduce((prev, current) => {
      const prevInicio = new Date(prev.fecha_inicio);
      const prevFin = new Date(prev.fecha_fin);
      const currentInicio = new Date(current.fecha_inicio);
      const currentFin = new Date(current.fecha_fin);
      return currentInicio > prevInicio ||
        (currentInicio.getTime() === prevInicio.getTime() &&
          currentFin > prevFin)
        ? current
        : prev;
    });
    return periodoMasReciente;
  };

  useEffect(() => {
    if (periodos) {
      // Solo establecer el periodo inicial si no hay un periodo seleccionado
      if (!selectedPeriodo) {
        const periodoInicial = getPeriodoMasReciente(periodos);
        setSelectedPeriodo(periodoInicial);
        setSelectedPeriodoId(periodoInicial?.id_periodo);
        if (periodoInicial) {
          getCursosDocente(periodoInicial.id_periodo);
        }
      } else {
        // Si ya hay un periodo seleccionado, simplemente recarga los cursos
        getCursosApi(selectedPeriodoId);
        getCursosDocente(selectedPeriodoId);
      }
    }
    // eslint-disable-next-line
  }, [periodos]);

  const formatPeriodo = (fecha) => {
    const opciones = { month: "long", year: "numeric" };
    const fechaFormateada = new Date(fecha).toLocaleDateString(
      "es-ES",
      opciones
    );
    return fechaFormateada.charAt(0).toUpperCase() + fechaFormateada.slice(1);
  };

  function formatoDropdownPeriodo(informacionCicloEscolar) {
    if (!informacionCicloEscolar || informacionCicloEscolar.length === 0) {
      return [];
    }
    return informacionCicloEscolar.map((item) => ({
      key: item.id_periodo,
      text: `${formatPeriodo(item.fecha_inicio)} - ${formatPeriodo(
        item.fecha_fin
      )}`,
      value: item.id_periodo,
    }));
  }

  const handlePeriodoChange = (event, data) => {
    const periodoSeleccionado = periodos.find(
      (periodo) => periodo.id_periodo === data.value
    );
    setSelectedPeriodo(periodoSeleccionado);
    setSelectedPeriodoId(data.value);
    getCursosApi(data.value); // Llamada a la API con el ID del periodo seleccionado
  };

  async function getCursosApi(periodoId) {
    try {
      setLoading(true);
      const response = await axios.get(
        `${BASE_API}/api/curso/?periodo=${periodoId}`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );
      const cursosData = response.data;
      // Filtrar cursos que no tienen docente y cuya materia no es de titulación
      const cursosSinDocente = cursosData.filter(
        (curso) => !curso.docente && !curso.materia_data.es_de_titulacion
      );
      const cursosTitulacion = cursosData.filter(
        (curso) => curso.materia_data.es_de_titulacion
      );
      setLoading(false);
      setCursos(cursosSinDocente);
      setCursosTitulacion(cursosTitulacion);
      return cursosSinDocente;
    } catch (error) {
      setLoading(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    if (selectedPeriodoId) {
      getCursosApi(selectedPeriodoId);
    }
    // eslint-disable-next-line
  }, [refetch, selectedPeriodoId]);

  async function getCursosDocente(periodoId) {
    try {
      setLoadingCursosDocente(true);
      const response = await axios.get(
        `${BASE_API}/api/curso/?periodo=${periodoId}&docente=${datosDocente.id}`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      const cursosDelDocente = response.data;
      setLoadingCursosDocente(false);
      setCursosDocente(cursosDelDocente);
      return cursosDelDocente;
    } catch (error) {
      setLoadingCursosDocente(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    if (selectedPeriodoId) {
      getCursosDocente(selectedPeriodoId);
    }
    // eslint-disable-next-line
  }, [refetch, selectedPeriodoId]);

  async function asignarCurso(curso) {
    try {
      setLoading(true);
      await axios.put(
        `${BASE_API}/api/curso/${curso.id}/`,
        {
          periodo: curso.periodo,
          materia: curso.materia,
          grupo: curso.grupo,
          docente: datosDocente.id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );
      setRefetch(!refetch);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  const desasignarCurso = async (datosCurso) => {
    const confirmMessage = `¿Seguro que desea desasginarle al docente el curso de ${datosCurso.materia_data.nombre_materia} del grupo
    ${datosCurso.grupo_data.numero_grupo}?`;

    const result = await Swal.fire({
      //title: '¿Estás seguro?',
      text: confirmMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí",
      confirmButtonColor: "#2f6d02",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "#920804",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        setLoading(true);
        await axios.put(
          `${BASE_API}/api/curso/${datosCurso.id}/`,
          {
            periodo: datosCurso.periodo,
            materia: datosCurso.materia,
            grupo: datosCurso.grupo,
            docente: null,
          },
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          }
        );
        setRefetch(!refetch);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        window.location.reload();
        window.location.href = "/Login";
      }
    }
  };

  async function getCursosTitulacionAsignados(docenteId, periodoId) {
    try {
      const response = await axios.get(
        `${BASE_API}/api/calificacion_curso/?docente_asesor=${docenteId}`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      const cursosData = response.data;
      const cursosFiltrados = cursosData.filter(
        (curso) => curso.curso_data.periodo === periodoId
      );

      const cursosAgrupados = cursosFiltrados.reduce((acc, curso) => {
        if (!acc[curso.curso]) {
          acc[curso.curso] = {
            ...curso.curso_data,
            alumnos: [],
          };
        }
        acc[curso.curso].alumnos.push(curso.alumno_data);
        return acc;
      }, {});

      // Convertir el objeto de agrupación en una lista
      const cursosAgrupadosList = Object.values(cursosAgrupados);
      return cursosAgrupadosList;
    } catch (error) {
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    if (selectedPeriodoId) {
      getCursosTitulacionAsignados(datosDocente.id, selectedPeriodoId).then(
        (cursos) => {
          setCursosAsignadosTitulacion(cursos);
        }
      );
    }
    // eslint-disable-next-line
  }, [refetch, selectedPeriodoId]);

  const renderContent = () => {
    switch (activeTab) {
      case "CursosDisponibles":
        return (
          <>
            <h6 className="sub">
              {" "}
              <Link to="/gestion-docente">Gestión docente </Link>/ Cursos
              disponibles
            </h6>
            {loadingPeriodos ? (
              <Loader active inline="centered">
                Cargando periodos....
              </Loader>
            ) : (
              <div
                style={{
                  maxWidth: "70%",
                  paddingBottom: "24px",
                }}
              >
                <div>
                  <h4 style={{ paddingBottom: "12px" }}>Filtrar por periodo</h4>
                </div>
                <Dropdown
                  placeholder="Seleccionar Periodo"
                  fluid
                  selection
                  options={formatoDropdownPeriodo(periodos)}
                  onChange={handlePeriodoChange}
                  value={selectedPeriodoId}
                />
              </div>
            )}

            {loading ? (
              <Loader active inline="centered">
                Cargando....
              </Loader>
            ) : (
              <TableCursosDispoibles
                cursos={cursos}
                asignarCurso={asignarCurso}
              />
            )}
          </>
        );
      case "CursosAsignados":
        return (
          <>
            <h6 className="sub">
              <Link to="/gestion-docente">Gestión docente </Link> / Cursos
              asignados
            </h6>
            {loadingPeriodos ? (
              <Loader active inline="centered">
                Cargando periodos....
              </Loader>
            ) : (
              <div
                style={{
                  maxWidth: "70%",
                  paddingBottom: "24px",
                }}
              >
                <div>
                  <h4 style={{ paddingBottom: "12px" }}>Filtrar por periodo</h4>
                </div>
                <Dropdown
                  placeholder="Seleccionar Periodo"
                  fluid
                  selection
                  options={formatoDropdownPeriodo(periodos)}
                  onChange={handlePeriodoChange}
                  value={selectedPeriodoId}
                />
              </div>
            )}
            {loading ? (
              <Loader active inline="centered">
                Cargando....
              </Loader>
            ) : (
              <TableCursosAsignados
                cursosDocente={cursosDocente}
                desasignarCurso={desasignarCurso}
              />
            )}
          </>
        );
      case "Practicantes disponibles":
        return (
          <>
            <h6 className="sub">
              <Link to="/gestion-docente">Gestión docente </Link> / Cursos
              asignados
            </h6>
            {loadingPeriodos ? (
              <Loader active inline="centered">
                Cargando periodos....
              </Loader>
            ) : (
              <div
                style={{
                  maxWidth: "70%",
                  paddingBottom: "24px",
                }}
              >
                <div>
                  <h4 style={{ paddingBottom: "12px" }}>Filtrar por periodo</h4>
                </div>
                <Dropdown
                  placeholder="Seleccionar Periodo"
                  fluid
                  selection
                  options={formatoDropdownPeriodo(periodos)}
                  onChange={handlePeriodoChange}
                  value={selectedPeriodoId}
                />
              </div>
            )}
            {loading ? (
              <Loader active inline="centered">
                Cargando....
              </Loader>
            ) : (
              <TablePracticantesDisponibles
                cursosTitulacion={cursosTitulacion}
                dataDocente={datosDocente}
              />
            )}
          </>
        );
      case "Practicantes asignados":
        return (
          <>
            <h6 className="sub">
              <Link to="/gestion-docente">Gestión docente </Link> / Cursos
              asignados
            </h6>
            {loadingPeriodos ? (
              <Loader active inline="centered">
                Cargando periodos....
              </Loader>
            ) : (
              <div
                style={{
                  maxWidth: "70%",
                  paddingBottom: "24px",
                }}
              >
                <div>
                  <h4 style={{ paddingBottom: "12px" }}>Filtrar por periodo</h4>
                </div>
                <Dropdown
                  placeholder="Seleccionar Periodo"
                  fluid
                  selection
                  options={formatoDropdownPeriodo(periodos)}
                  onChange={handlePeriodoChange}
                  value={selectedPeriodoId}
                />
              </div>
            )}
            {loading ? (
              <Loader active inline="centered">
                Cargando....
              </Loader>
            ) : (
              <TablePracticantesAsignados
                practicantesAsignados={cursosAsignadosTitulacion}
                dataDocente={datosDocente}
              />
            )}
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <h1 className="tituloin">
        Asignación de cursos al docente: {datosDocente.first_name}{" "}
        {datosDocente.last_name} {" - "}
        {datosDocente.categoria}
      </h1>
      <div className="ui top attached tabular menu">
        <button
          className={`item ${
            activeTab === "CursosDisponibles" ? "active" : ""
          }`}
          onClick={() => setActiveTab("CursosDisponibles")}
        >
          <h1 className="subtituloin">Cursos disponibles</h1>
        </button>
        <button
          className={`item ${activeTab === "CursosAsignados" ? "active" : ""}`}
          onClick={() => setActiveTab("CursosAsignados")}
        >
          <h1 className="subtituloin">Cursos asignados</h1>
        </button>
        <button
          className={`item ${
            activeTab === "Practicantes disponibles" ? "active" : ""
          }`}
          onClick={() => setActiveTab("Practicantes disponibles")}
        >
          <h1 className="subtituloin">Practicantes disponibles</h1>
        </button>
        <button
          className={`item ${
            activeTab === "Practicantes asignados" ? "active" : ""
          }`}
          onClick={() => setActiveTab("Practicantes asignados")}
        >
          <h1 className="subtituloin">Practicantes asignados</h1>
        </button>
        <div className="right menu">
          <div className="item"></div>
        </div>
      </div>
      <div className="ui bottom attached segment">{renderContent()}</div>
    </div>
  );
}

export default AsignacionCursos;
